import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">

      <p class="mb-3">
        Лекция о межкультурном взаимо(не)понимании для эсперантистов, т.е. людей различных культур, 
        говорящих на одном языке. 
        Читает преподаватель университета, ведущая как раз курс социальных межличностных отношений.
      </p>
      
      <p class="mb-3">
        Именно <u>читает</u>, не отрываясь от своих бумажек, по которым готовилась к лекциям на работе. 
        И это очень хорошо, потому что мы видим-слышим здесь незамутнённый, 
        в оригинале поток сознания протестантской культуры. 
        Это не англосаксы, но то непонятное ЧМО, что когда-то было гёзами, т.е. нищими, – а теперь выродилось в какой-то гнойник Европы, 
        очаг отморозков, нагло топчущий (бывшую) европейскую нравственность и культуру. 
        Ведь недаром Англия никогда не принадлежала к Европе (и уже вышла из Европейского Союза😀, 
        куда вступила по глупости и оплошности) и всегда подчёркивала свою отдельность от «континента». 
        О США нечего и говорить – выкидыш Европы, бастард. 
      </p>
      
      <p class="mb-3">
        Протестанство завладело также севером Европы, куда происходил «дрейф генов», т.е. вытеснялись рецессивы. 
        И вот всё это, неполноценное физически и морально, благодаря мощи далёкой СШАвии, где никогда не шла война на её территории, 
        сейчас ободрилось и, как любое меньшинство, стало навязывать свои идеи большинству. 
        Ведь суть демократии именно в в наглом навязывании большинству воли меньшинства, хотя по идее, по смыслу слова, должно быть наоборот. 
      </p>
      
      <p class="mb-3">
        Но разве сейчас кто-то обращает внимание на смысл слова? 
        Появилось даже выражение «смыслЫ», взятое тоже, конечно, из английского языка. 
        И так опять-таки размывается истина: нет единой ПРАВДЫ, нет единственного смысла у употреблённого слова; 
        всё амбивалентно, правда есть ложь, мужчина есть женщина, жизнь есть смерть. 
        Очень хочется кому-то, чтобы для всех всё стало так, и все обнулились и исчезли. 
        Если ещё лет пять назад об этом можно было догадываться, то теперь уже то же самое говорят открыто. 
        Значит, всего за десяток лет человечество сделало гигантский шаг к самоуничтожению, а те, кто его направляет по этому пути, 
        сильно укрепились на своих позициях. 
        Нынешняя «эпидемия» – большой шаг в этом направлении: все послушно развалили свои дома и надели намордники. 
        А тех, кто не послушался – в этой же Голландии быстро и результативно, дубинками, водомётами и оружием усмиряют до смерти. 
        Это вам не «демократия, свобода слова и права человека» – это попытка выйти из-под той власти, которая уже стала реальной, 
        правящей властью; и любое сопротивление она будет жёстко подавлять в зародыше.
      </p>
      
      <p class="mb-3">
        Но вернёмся к нашим баранам, точнее стаду баранов, перед которым ораторствует облезлая, но хитроумная лиса. 
        Она <u>учит</u> международную аудиторию, чтó есть «культура вины» и чтó есть «культура стыда»… и делает парадоксальный вывод, 
        что именно культура вины сдерживает человека от совершения плохих поступков, когда он один и его никто не видит. 
        А стыд позволяет, наоборот, всё что угодно!
      </p>
      
      <p class="mb-3">
        Да как же это может быть, если СТЫД, а точнее СОВЕСТЬ – это как раз единственное, что может удержать человека от «греха», 
        независимо от любого его положения и окружения! 
        Это как раз и есть встроенный судья, сугубо индивидуальный, который <u>всегда</u> с тобой, знает <u>все</u> твои помыслы и поступки и судит неподкупно. 
        Только совесть может управлять по-настоящему нравственным человеком. 
        И это как раз самое индивидуальное чувство. 
      </p>
      
      <p class="mb-3">
        А вина – это понятие не индивидуальной нравственности, а социальных норм, т.е. <u>закона</u>. 
        И если рядом нет блюстителя этого закона, то всё позволено: ведь никто не увидит и не узнает! 
        <u>Внутренних</u> ограничителей при понятии вины нет совсем: всё, что удерживает здесь человека – это <u>закон</u>, т.е внешний фактор; 
        и если нет этого внешнего ограничителя, нормы (т.е. нет лиц, могущих зафиксировать это отклонение от нормы), 
        –– тогда ничто не может удержать человека, «всё дозволено». 
        Как можно этого не понимать?!? 
        Вернее, сознательно не принимать, утверждая прямо противоположное реальности, но выгодное с точки зрения … политики? религии?
      </p>
      
      <p class="mb-3">
        Вот это и есть политика двойных стандартов, въевшаяся в плоть и кровь европейцев, ставшая основой их мышления, 
        так что они и не представляют, как можжно думать иначе. 
        Рабское мышление, покорность стереотипам, и главное – смешная и глупая уверенность, что именно они – соль земли и разум мира. 
        Но с разумом, к сожалению, давно покончено…
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Нечто о взаимопонимании`
}

const itemDate = {
  rus: `1998 год`
}

const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemDate: itemDate.rus,
    itemAuthor: author.rus
  }
}

export default item;